import * as Types from '../actions/customer/CustomerActionTypes';

const initialState = [];

const customerReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
    case Types.CREATE_CUSTOMER:
        console.log('CREATE_CUSTOMER called with data', payload);
        return [payload];
    case Types.READ_CUSTOMER:
        console.log('reducer called with data', payload);
        if (payload.customerId === 0) return payload.customer;
        return payload.customer;
    case Types.UPDATE_CUSTOMER:
        console.log('UPDATE_CUSTOMER called with data', payload);
        return state.map((customer) =>
            customer.customerId === payload.customerId ? payload : customer
        );
    case Types.DELETE_CUSTOMER:
        console.log(state);
        // return state && state.filter((customer) => customer.customerId !== payload);
        return [];

    case Types.GET_TRACKING_BY_ID:
        console.log('GET_TRACKING_BY_ID', payload);
        return state.map((tracking) => (tracking.trackingId === payload.trackingId ? payload : tracking));

    case Types.GET_ALL_TRACKINGS:
        console.log('GET_ALL_TRACKINGS', payload);
        return payload;
    case Types.CLEAR_STATE:
        return payload;
    default:
        return state;
    }
};

export default customerReducer;
